export default function buildMakeFireFlowTestHydrant({ validate, validators, makeFireFlowTest }) {
  return function makeFireFlowTestHydrant({
    id,
    companyId,
    fireFlowTestId,
    hydrantId,
    staticPSI,
    residualPSI,
    percentDrop,
    createdBy,
    createdDate = new Date(),
    modifiedBy,
    modifiedDate = new Date(),
    deletedBy,
    deletedDate,

    fireFlowTest
  }) {
    const schema = {
      id: {
        prettyName: 'ID',
        validators: [validators.isString(), validators.exactLength(36)],
      },
      companyId: {
        prettyName: 'Company ID',
        validators: [validators.isString(), validators.exactLength(36)],
      },
      hydrantId: {
        prettyName: 'Hydrant ID',
        validators: [validators.isString(), validators.exactLength(36)],
      },
      staticPSI: {
        prettyName: 'Static PSI',
        validators: [validators.isNumber()],
      },
      residualPSI: {
        prettyName: 'Residual PSI',
        validators: [validators.isNumber()],
      },
      percentDrop: {
        prettyName: 'Percent Drop',
        validators: [validators.isNumber()],
      },
    };

    return Object.freeze({
      get id() { return id },
      get companyId() { return companyId },
      get fireFlowTestId() { return fireFlowTestId },
      get hydrantId() { return hydrantId },
      get staticPSI() { return staticPSI },
      get residualPSI() { return residualPSI },
      get percentDrop() { return percentDrop },
      get createdBy() { return createdBy },
      get createdDate() { return createdDate ? new Date(createdDate) : null },
      get modifiedBy() { return modifiedBy },
      get modifiedDate() { return modifiedDate ? new Date(modifiedDate) : null },
      get deletedBy() { return deletedBy },
      get deletedDate() { return deletedDate ? new Date(deletedDate) : null },
      get fireFlowTest() { return fireFlowTest && makeFireFlowTest ? makeFireFlowTest(fireFlowTest) : null },
      validate() {
        const errors = validate(this, schema);
        if (errors.length > 0) {
          const message = errors.map(e => e.name + ': ' + e.message).join('\n');
          const validationError = new Error(message);
          validationError.name = 'ValidationError';
          throw validationError;
        }
      }
    });
  }
}